import { Framework } from '@/framework/instance';

type ActionType = 'delete' | 'paste' | 'addOrDelRowOrColByCellsSelectedInfo';

export class TableAction extends Framework {
    private eventName = 'tableAction';

    emit = (actionType: ActionType) => {
        this.framework.events.emit(this.eventName, actionType);
    };

    on = (cb: (actionType: ActionType) => void) => {
        const listenerId = this.framework.events.on(this.eventName, cb);
        const rmListener = () => {
            this.framework.events.off(listenerId);
        };
        return rmListener;
    };
}
